import { CRUDPathSegmentEn } from '../../constants';
const erpPaths = (module, type, subModule) => {
    const base = subModule ? `/erp/${module}/${subModule}/${type}` : `/erp/${module}/${type}`;
    return {
        list: base,
        detail: base + CRUDPathSegmentEn.DETAIL,
        detailByCode: base + CRUDPathSegmentEn.DETAIL_BY_CODE,
        add: base + CRUDPathSegmentEn.ADD,
        edit: base + CRUDPathSegmentEn.EDIT
    };
};
// planning
export const planningPaths = {
    pr: erpPaths('planning', 'pr'),
    pq: erpPaths('planning', 'pq'),
    so: erpPaths('planning', 'so'),
    sr: erpPaths('planning', 'sr'),
    itr: erpPaths('planning', 'itr')
};
// purchase
export const purchasePaths = {
    pqr: erpPaths('purchase', 'purchase-quotation-request'),
    purchaseOrder: erpPaths('purchase', 'purchase-order')
};
// inventory
export const inventoryPaths = {
    grpo: erpPaths('inventory', 'grpo'),
    it: erpPaths('inventory', 'it')
};
// production
export const productionPaths = {
    productionOrder: erpPaths('contract-execution', 'production', 'production-order'),
    productionRequest: erpPaths('contract-execution', 'production', 'production-request')
};
